/** Shared gallery filter values. `'all'` means "no filter". */

export type ImagePromptModel = 'all' | 'gptimage' | 'nanobanana';

export type ImagePromptSort = 'recent' | 'popular' | 'random';

/** Runtime list kept in lockstep with `ImagePromptModel`. */
export const IMAGE_PROMPT_MODEL_VALUES = [
  'all',
  'gptimage',
  'nanobanana',
] as const satisfies readonly ImagePromptModel[];

/** Runtime list kept in lockstep with `ImagePromptSort`. */
export const IMAGE_PROMPT_SORT_VALUES = [
  'recent',
  'popular',
  'random',
] as const satisfies readonly ImagePromptSort[];

/** Fixed categories mirrored from the imported prompt dataset. */
export const IMAGE_PROMPT_CATEGORIES = [
  { slug: 'food-drink', title: 'Food & Drink' },
  { slug: 'illustration-3d', title: 'Illustration & 3D' },
  { slug: 'photography', title: 'Photography' },
  { slug: 'poster-design', title: 'Poster Design' },
  { slug: 'product-brand', title: 'Product & Brand' },
  { slug: 'ui-graphic', title: 'UI & Graphic' },
] as const satisfies readonly { slug: string; title: string }[];

export type ImagePromptCategory =
  | 'all'
  | (typeof IMAGE_PROMPT_CATEGORIES)[number]['slug'];

export const DEFAULT_IMAGE_PROMPT_SORT: ImagePromptSort = 'recent';
export const DEFAULT_IMAGE_PROMPT_MODEL: ImagePromptModel = 'all';
export const DEFAULT_IMAGE_PROMPT_CATEGORY: ImagePromptCategory = 'all';
